/**
 * How many machines is a scanned `washerDryer` box actually holding?
 *
 * RoomPlan reports a washer and dryer as ONE combined object, so the count and
 * arrangement have to be read back off the box's proportions. A single
 * front-load machine is roughly 27" wide x 38" tall — an aspect ratio near 0.7.
 * Setting two side by side doubles the width (~1.4); stacking two doubles the
 * height (~0.35). The two thresholds below sit at the midpoints between those
 * three cases.
 *
 * The test is deliberately a RATIO rather than an absolute size, so it is
 * scale-free: a scan that came out 10% small still lands in the same band. The
 * upper bound is the `width > height` rule this file has always used; only the
 * lower bound is new, splitting what used to be a catch-all "stacked" branch
 * into "one machine" and "two stacked".
 */

/** Above this width/height ratio the box is wide enough to hold two machines. */
const SIDE_BY_SIDE_RATIO = 1.0;
/** Below this width/height ratio the box is tall enough to hold two machines. */
const STACKED_RATIO = 0.5;

export const LAUNDRY_SIDE_BY_SIDE = 'side-by-side';
export const LAUNDRY_STACKED = 'stacked';
export const LAUNDRY_SINGLE = 'single';

/**
 * @param {{width: number, height: number}} dimensions - the scanned box
 * @returns {'side-by-side'|'stacked'|'single'}
 */
export function classifyLaundryArrangement({ width, height }) {
  const ratio = width / height;
  if (ratio > SIDE_BY_SIDE_RATIO) return LAUNDRY_SIDE_BY_SIDE;
  if (ratio < STACKED_RATIO) return LAUNDRY_STACKED;
  return LAUNDRY_SINGLE;
}
